const InventoryEndpoint = {
  index () {
    return {
      url: '/inventories',
      method: 'GET',
    }
  },
  update (form) {
    return {
      url: `/inventories/${form['id']}`,
      method: 'PUT',
      body: JSON.stringify({ inventory: form })
    }
  },
  create (form) {
    return {
      url: '/create_inventory',
      method: 'POST',
      body: JSON.stringify({ inventory: form })
    }
  },
  destroy (form) {
    return {
      url: '/destroy_inventory',
      method: 'POST',
      body: JSON.stringify({ inventory: form })
    }
  }
}

export default InventoryEndpoint



// WEBPACK FOOTER //
// ./src/persistence/InventoryEndpoint.js